import { Component, OnInit } from '@angular/core';
import { AppStateService } from 'apps/legacy/src/app/app-state.service';
import { UserEventsService } from 'apps/legacy/src/app/userEvents/services/userEvents.service';
import { combineLatest } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { ApplicationLoginContext, RouteResources } from '../../models';
import { LoginDestination } from '../../models/login-destination';
import { ApplicationRouteService } from '../../services';
import { SwitchAccountService } from '../../services/switch-account.service';

@Component({
  template: ''
})
export class PortalRedirectComponent implements OnInit {
  constructor(
    private appStateService: AppStateService,
    private applicationRouteService: ApplicationRouteService,
    private switchAccountService: SwitchAccountService,
    private userEventsService: UserEventsService
  ) {}

  ngOnInit() {
    this.userEventsService.addUserEvent('Shared.PortalRedirect');

    combineLatest([
      this.appStateService.getSwitchableLogins$(),
      this.appStateService.old_assumedUserId$,
      this.appStateService.applicationLoginContext$
    ])
      .pipe(
        first(),
        map(([switchableLogins, assumedUserId, applicationLoginContext]) => {
          if (applicationLoginContext === ApplicationLoginContext.Portal) return false;

          const portalUsers =
            switchableLogins &&
            switchableLogins.filter((user) => user.UserId === assumedUserId && user.Destination === LoginDestination.Portal);

          if (!portalUsers || portalUsers.length <= 0) {
            return;
          }

          this.switchAccountService.getSwitchUserToken(portalUsers[0].UserId, portalUsers[0].Destination).subscribe((res) => {
            window.location.href = RouteResources.casPortalSwitchUser(res.token);
          });
        })
      )
      .subscribe();
  }
}
